module.exports = __webpack_public_path__ + "media/images/video_conference-c2e203e67a87fe74e54305aa2c47ce888beed8956adf79a03b49dd61f5c9352b.jpg";